export function NoSearchResultsIllustration() {
  return (
    <svg
      width="200"
      height="160"
      viewBox="0 0 200 160"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Magnifying glass */}
      <circle cx="80" cy="70" r="35" fill="white" stroke="#D1D5DB" strokeWidth="3" />
      <circle cx="80" cy="70" r="25" fill="#F3F4F6" />

      {/* Handle */}
      <path
        d="M105 95 L130 120"
        stroke="#D1D5DB"
        strokeWidth="8"
        strokeLinecap="round"
      />

      {/* X mark inside glass */}
      <path
        d="M70 60 L90 80 M90 60 L70 80"
        stroke="#9CA3AF"
        strokeWidth="3"
        strokeLinecap="round"
      />

      {/* Document lines */}
      <rect x="50" y="110" width="100" height="2" rx="1" fill="#E5E7EB" />
      <rect x="60" y="120" width="80" height="2" rx="1" fill="#E5E7EB" />
      <rect x="70" y="130" width="60" height="2" rx="1" fill="#E5E7EB" />
    </svg>
  );
}
